import axios from '../../plugins/axios'

export const fetchAssignments = ({ commit }) => {
  return axios.get('/assignments')
    .then((response) => {
      const assignments = response.data
      commit('SET_ASSIGNMENTS', { assignments })
      return response
    },
      (error) => {
        console.error(error)
      }
    )
}

export const createAssignmentRequestFromDeliveryId = (_, payload) => {
  return axios.post('/assignment-request/from-delivery-id', payload)
}

export const createAssignmentRequestFromImage = (_, payload) => {
  return axios.post(
    '/assignment-request/from-image',
    payload,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    }
  )
}

export const listDriverAssignmentRequests = ({ commit }, { params } = {}) => {
  return axios.get('/assignment-request', { params })
}

export const createDriverAssignmentRequest = ({ commit }, payload) => {
  return axios.post('/driver-assignment-request', payload.data)
}

export const acceptAssignmentRequestItem = ({ commit }, payload) => {
  return axios.post(`/assignment-request/item/${payload.id}/accept`)
}

export const rejectAssignmentRequestItem = ({ commit }, payload) => {
  return axios.post(`/assignment-request/item/${payload.id}/reject`)
}

export const getAssignmentRequestItem = ({ commit }, id) => {
  return axios.get(`/assignment-request/item/${id}`)
}

export const getAssignmentRequestItemCounters = ({ commit }, { params } = {}) => {
  return axios.get('/assignment-request/counters', { params })
}

export const getAssignmentRequestItemCountPending = ({ commit }, { params } = {}) => {
  return axios.get('/assignment-request/item/count-pending', { params })
    .then((response) => {
      commit('SET_COUNT_PENDING', response.data.count)
      return response
    }, (error) => {
      console.error(error)
    })
}